import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';

const ApplicationSettings = () => {
    const [googleApiKey, setGoogleApiKey] = useState('');
    const [openAiApiKey, setOpenAiApiKey] = useState('');
    const [hfApiKey, setHfApiKey] = useState('');
    const [googleCredentialsFile, setGoogleCredentialsFile] = useState(null);

    const handleFileChange = (event) => {
        setGoogleCredentialsFile(event.target.files[0]);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        alert('API Keys and credentials saved successfully! 🎉');
        // In a real application, this would involve backend communication to save the keys
    };

    return (
        <Container className="mt-5">
            <h2>Application Settings</h2>
            <Form onSubmit={handleSubmit}>
                {/* Google API Key Section */}
                <Row className="mb-4">
                    <Col>
                        <h4>Google API Key</h4>
                        <p>
                            To obtain your Google API key:
                            <ol>
                                <li>Go to the <a href="https://console.cloud.google.com/" target="_blank" rel="noopener noreferrer">Google Cloud Console</a>.</li>
                                <li>Click on <strong>APIs & Services</strong> → <strong>Credentials</strong>.</li>
                                <li>Click <strong>Create credentials</strong> → <strong>API key</strong>.</li>
                                <li>Copy the generated API key and paste it below.</li>
                            </ol>
                        </p>
                        <Form.Control 
                            type="text" 
                            placeholder="Enter your Google API Key" 
                            value={googleApiKey}
                            onChange={(e) => setGoogleApiKey(e.target.value)}
                        />
                    </Col>
                </Row>

                {/* OpenAI API Key Section */}
                <Row className="mb-4">
                    <Col>
                        <h4>OpenAI API Key</h4>
                        <p>
                            To obtain your OpenAI API key:
                            <ol>
                                <li>Visit <a href="https://platform.openai.com/account/api-keys" target="_blank" rel="noopener noreferrer">OpenAI API keys page</a>.</li>
                                <li>Click <strong>Create new secret key</strong> and copy the key.</li>
                                <li>Paste the key in the field below.</li>
                            </ol>
                        </p>
                        <Form.Control 
                            type="text" 
                            placeholder="Enter your OpenAI API Key" 
                            value={openAiApiKey}
                            onChange={(e) => setOpenAiApiKey(e.target.value)}
                        />
                    </Col>
                </Row>

                {/* Hugging Face API Key Section */}
                <Row className="mb-4">
                    <Col>
                        <h4>Hugging Face API Key</h4>
                        <p>
                            To obtain your Hugging Face API key:
                            <ol>
                                <li>Visit <a href="https://huggingface.co/settings/tokens" target="_blank" rel="noopener noreferrer">Hugging Face tokens page</a>.</li>
                                <li>Click <strong>Create new token</strong> and copy the token.</li>
                                <li>Paste the token in the field below.</li>
                            </ol>
                        </p>
                        <Form.Control 
                            type="text" 
                            placeholder="Enter your Hugging Face API Key" 
                            value={hfApiKey}
                            onChange={(e) => setHfApiKey(e.target.value)}
                        />
                    </Col>
                </Row>

                {/* Google Cloud JSON File Section */}
                <Row className="mb-4">
                    <Col>
                        <h4>Google Cloud Credentials (JSON)</h4>
                        <p>
                            To obtain your Google Cloud credentials JSON file:
                            <ol>
                                <li>Visit the <a href="https://console.cloud.google.com/" target="_blank" rel="noopener noreferrer">Google Cloud Console</a>.</li>
                                <li>Go to <strong>APIs & Services</strong> → <strong>Credentials</strong>.</li>
                                <li>Click <strong>Create credentials</strong> → <strong>Service account</strong>.</li>
                                <li>Create a new service account and download the JSON credentials file.</li>
                                <li>Upload the JSON file below.</li>
                            </ol>
                        </p>
                        <Form.Control 
                            type="file" 
                            accept=".json" 
                            onChange={handleFileChange} 
                        />
                        {googleCredentialsFile && <p>File selected: {googleCredentialsFile.name}</p>}
                    </Col>
                </Row>

                {/* Save Button */}
                <Button variant="primary" type="submit">
                    Save
                </Button>
            </Form>
        </Container>
    );
};

export default ApplicationSettings;
